export type RecordBadge = {
  icon: string;
  title: string;
};

export const recordBadges: Record<string, RecordBadge> = {
  bspn: {
    icon: '/icons/big_snp.svg',
    title: 'Самый дальний выстрел (сн. винт. 12.7 мм)',
  },
  mspn: {
    icon: '/icons/sm_snp.svg',
    title: 'Самый дальний выстрел (сн. винт. до 12.7 мм)',
  },
  omp: {
    icon: '/icons/veh_frag.svg',
    title: 'Наибольшее кол-во фрагов за одну игру (техника)',
  },
  term: {
    icon: '/icons/max_inf.svg',
    title: 'Наибольшее кол-во фрагов за одну игру (пехота)',
  },
  avi: {
    icon: '/icons/jet.svg',
    title: 'Наибольшее кол-во фрагов за одно СГ (пилоты)',
  },
};
